export class AddContactTypeResultDto {
  contactTypeId: number;
  displayText: string;
}
